// ** React Imports
import { useState, useEffect, SyntheticEvent, ChangeEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete,
    TableCell,
    FormGroup
} from '@mui/material'

import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import MsiDatagridAutoPlain from '../../../../components/custom/MsiDatagridAutoPlain';
import moment from 'moment';
import React from 'react';


const tableFixHead = { position: 'sticky', top: 0, zIndex: 3 }
const styleCell = {
    textAlign: 'center',
    border: '0.5px solid rgba(0, 0, 0, 0.12)'
}
const styleCellInput = {
    width: 120,
    textAlign: 'center',
    border: '0.5px solid rgba(0, 0, 0, 0.12)'
}
const titleHeader = {
    textTransform: 'none',
    color: '#212121',
    textAlign: 'center',
    fontWeight: 600,
    fontSize: 15
}
const contentPrimary = {
    color: '#212121',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15
}
const contentPrimaryInfo = {
    color: '#4472C4',
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 15
}

const checkExtension = (fileName: any) => {
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1)

    return extension
}

const tampilkanGambar = (url: string) => {
    if (
        url != '' &&
        url !=
        'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
    ) {
        Swal.fire({
            imageUrl: url,
            imageAlt: 'Gambar'
        })
    } else {
        Swal.fire({
            icon: 'warning',
            title: 'Pemberitahuan',
            text: 'Gambar Tidak Tersedia'
        })
    }
}

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    // ** State
    const [stockSummary, setStockSummary] = useState<any[]>([])
    const [detaiPoPr, setDetailPoPr] = useState<any[]>([])
    const [itemPembanding, setItemPembanding] = useState<any[]>([])
    const [historyPembelian, setHistoryPembelian] = useState<any[]>([])

    const [selected, setSelected] = useState<any>(null)
    const [kirimItem, setKirimItem] = useState<any>(null)

    const [isOto, setIsOto] = useState<any>(null)

    const [modeSave, setModeSave] = useState<any>(null)

    useEffect(() => {
        getDetail()
    }, [])

    const getDetail = () => {
        // Swal.fire({
        //     title: 'Now loading',
        //     allowEscapeKey: false,
        //     allowOutsideClick: false,
        //     didOpen: () => {
        //         Swal.showLoading()
        //     }
        // })

        const url = apiUrl.apiUrl + '/purchasing/po/detail-pr'
        axios
            .get(url, {
                params: { pbpr_d_id: id },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data.map((row: any, index: any) => ({
                        ...row,
                        id: index + 1
                    }));

                    setDetailPoPr(data)

                    getStockSummary()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getStockSummary = () => {
        const url = apiUrl.apiUrl + '/purchasing/po/stock-summary'
        axios
            .get(url, {
                params: { id: id },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setStockSummary(data)

                    getItemPembanding()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getItemPembanding = () => {
        const url = apiUrl.apiUrl + '/purchasing/po/detail-item-pembanding'
        axios
            .get(url, {
                params: {
                    id: id,
                    mode: 0
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setItemPembanding(data)

                    getHistoryPembelian()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getHistoryPembelian = () => {
        const url = apiUrl.apiUrl + '/purchasing/po/history-pembelian'
        axios
            .get(url, {
                params: {
                    id: id
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data.map((row: any, index: any) => ({
                        ...row,
                        id: index + 1
                    }));
                    setHistoryPembelian(data)
                    getCheck()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getCheck = () => {
        const url = apiUrl.apiUrl + '/purchasing/po/get-cek-oto-user'
        axios
            .get(url, {
                params: { sysdoctag_id: 4 },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    console.log(data)
                    setIsOto(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const navigate = useNavigate();

    interface FormInputs {
        pbsupplier_id: any
        pbpr_d_id: any
        mmbarang_id: any,
        qty: any,
        harga: any,
        keterangan: any,
        supplier: any,
        eta: any
    }

    const defaultValues = {
        pbpr_d_id: id,
        keterangan: ''
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const changeRadio = (index: any) => {
        setSelected(index)
        const rows = [...itemPembanding]
        const val = rows[index]
        setKirimItem(val)
        setValue('eta', val?.eta)
        setValue('harga', val?.harga)
        setValue('pbsupplier_id', val?.pbsupplier_id)
        setValue('mmbarang_id', val?.mmbarang_id)
        setValue('supplier', val?.supplier)
        setValue('qty', val?.qty)
    }

    const changeInput = (index: any, evnt: any) => {
        const { name, value } = evnt.target
        const rows = [...itemPembanding]
        rows[index][name] = value
        setItemPembanding(rows)
    }

    const onSubmit = (data: any) => {
        if (kirimItem == null) {
            Swal.fire({
                title: 'Pemberitahuan',
                text: 'Item Pembanding belum dipilih',
                icon: 'error'
            })
        } else {
            Swal.fire({
                title: 'Konfirmasi',
                text: 'Apakah anda ingin menyimpan data ini ?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#337ab7',
                cancelButtonColor: '#ffc107',
                confirmButtonText: 'Simpan'
            }).then(result => {
                if (result.isConfirmed) {
                    // Swal.fire({
                    //     title: 'Now loading',
                    //     allowEscapeKey: false,
                    //     allowOutsideClick: false,
                    //     didOpen: () => {
                    //         Swal.showLoading()
                    //     }
                    // })

                    let url = ''
                    if (modeSave == 'save') {
                        url = apiUrl.apiUrl + '/purchasing/po/add-oto-po'
                    } else {
                        url = apiUrl.apiUrl + '/purchasing/po/add-po'
                    }

                    axios
                        .post(url, data, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                Swal.fire({
                                    title: 'Pemberitahuan',
                                    text: response.data.message,
                                    icon: 'success',
                                    timer: 1000,
                                    timerProgressBar: true,
                                    willClose: () => {
                                        const id = response.data.data
                                        navigate('/purchasing/purchase-order')
                                    }
                                })
                            } else {
                                Swal.fire({
                                    title: 'Pemberitahuan',
                                    text: response.data.message,
                                    icon: 'error'
                                })
                            }
                        })
                        .catch(error => {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: error.message,
                                icon: 'error'
                            })
                        })
                }
            })
        }
    }

    const customRender = [
        {
            key: "nama_barang",
            renderCell: (row: any) => (
                <div style={{ cursor: 'pointer' }} onClick={() => navigate('/mm/master-barang/detail/' + row.id)}>
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                        {row.value}
                    </Typography>
                </div>
            ),
        },
        {
            key: "is_stok",
            renderCell: (row: any) => {
                return (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={row.value} readOnly name='controlled' />}
                    />
                )
            },
        },
        {
            key: "is_asset",
            renderCell: (row: any) => {
                return (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={row.value} readOnly name='controlled' />}
                    />
                )
            },
        },
    ];

    const customRenderPoPr = [
        {
            key: "id_pr",
            renderCell: (row: any) => (
                <div style={{ cursor: 'pointer' }} onClick={() => navigate('/purchasing/purchase-request/detail/' + row.id)}>
                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                        {row.value}
                    </Typography>
                </div>
            ),
        },
    ];

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Purchase Order
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Typography variant='body1' sx={{ mt: 2, mb: 1, fontSize: 18, fontWeight: '600' }}>
                            Stock Summary
                        </Typography>
                        <MsiDatagridAutoPlain array={stockSummary} hiddenColumns={['i', 'id', 'is_stok', 'is_asset']} customRender={customRender} />
                        <Typography variant='body1' sx={{ mt: 2, mb: 1, fontSize: 18, fontWeight: '600' }}>
                            Detail PR & PO
                        </Typography>
                        <MsiDatagridAutoPlain array={detaiPoPr} customRender={customRenderPoPr} hiddenColumns={['id', 'pbpr_d_id']} />
                        <Typography variant='body1' sx={{ mt: 2, mb: 1, fontSize: 18, fontWeight: '600' }}>
                            Item Pembanding
                        </Typography>
                        <TableContainer>
                            <Table stickyHeader sx={{ width: '100%' }}>
                                <TableHead sx={tableFixHead}>
                                    <TableRow>
                                        <TableCell sx={styleCell}>
                                            <Typography sx={titleHeader}>Supplier</Typography>
                                        </TableCell>
                                        <TableCell sx={styleCell}>
                                            <Typography sx={titleHeader}>Nama Item</Typography>
                                        </TableCell>
                                        <TableCell sx={styleCell}>
                                            <Typography sx={titleHeader}>Harga Unit</Typography>
                                        </TableCell>
                                        <TableCell sx={styleCell}>
                                            <Typography sx={titleHeader}>Last Update</Typography>
                                        </TableCell>
                                        <TableCell sx={styleCell}>
                                            <Typography sx={titleHeader}>Updated By</Typography>
                                        </TableCell>
                                        <TableCell sx={styleCellInput}>
                                            <Typography sx={titleHeader}>Qty</Typography>
                                        </TableCell>
                                        <TableCell sx={styleCell}>
                                            <Typography sx={titleHeader}>Total</Typography>
                                        </TableCell>
                                        <TableCell sx={styleCell}>
                                            <Typography sx={titleHeader}></Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {itemPembanding.map((item, index) => (
                                        <TableRow
                                            key={index}
                                            selected={selected == index ? true : false}
                                            sx={{
                                                backgroundColor: index % 2 ? '#E5E5E5' : '#fff'
                                            }}
                                        >
                                            <TableCell sx={styleCell}>
                                                <Typography sx={contentPrimary}>{item.supplier}</Typography>
                                            </TableCell>
                                            <TableCell sx={styleCell}>
                                                <Typography sx={contentPrimary}>{item.nama_item}</Typography>
                                            </TableCell>
                                            <TableCell sx={styleCell}>
                                                <Typography sx={contentPrimary}>
                                                    {item.harga.toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={styleCell}>
                                                <Typography sx={contentPrimary}>{item.last_update}</Typography>
                                            </TableCell>
                                            <TableCell sx={styleCell}>
                                                {item.link == null ? (
                                                    <Typography sx={contentPrimary}>{item.updated_by}</Typography>
                                                ) : (
                                                    <>
                                                        {checkExtension(item.link) == 'pdf' || checkExtension(item.link) == 'docx' || checkExtension(item.link) == 'xlsx' ? (
                                                            <div onClick={() => window.open(item.link, '_blank')} style={{ cursor: 'pointer' }}>
                                                                <Typography sx={contentPrimaryInfo}>{item.updated_by}</Typography>
                                                            </div>
                                                        ) : (
                                                            <div onClick={() => window.open(item.link, '_blank')} style={{ cursor: 'pointer' }}>
                                                                <Typography sx={contentPrimaryInfo}>{item.updated_by}</Typography>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </TableCell>
                                            <TableCell sx={styleCellInput}>
                                                <TextField
                                                    sx={{ width: 100 }}
                                                    label='Qty'
                                                    name='qty'
                                                    type='number'
                                                    onChange={evnt => changeInput(index, evnt)}
                                                    defaultValue={item.qty}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </TableCell>
                                            <TableCell sx={styleCell}>
                                                <Typography sx={contentPrimary}>
                                                    {(item.harga * item.qty).toLocaleString('id-ID', { maximumFractionDigits: 2 })}
                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={styleCell}>
                                                {item.pbpo_id != null ? (
                                                    <input type='radio' onChange={() => changeRadio(index)} defaultChecked name={'radio'} />
                                                ) : (
                                                    <input type='radio' onChange={() => changeRadio(index)} name={'radio'} />
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography variant='body1' sx={{ mt: 2, mb: 1, fontSize: 18, fontWeight: '600' }}>
                            History Pembelian
                        </Typography>
                        <MsiDatagridAutoPlain array={historyPembelian} />
                        <Grid
                            container
                            spacing={5}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-evenly',
                                mt: 5
                            }}
                        >
                            {(() => {
                                if (isOto > 0) {
                                    return (
                                        <>
                                            <Button
                                                size='large'
                                                sx={{ mr: 2, width: 150 }}
                                                variant='contained'
                                                onClick={() => setModeSave('save')}
                                                type='submit'
                                            >
                                                Simpan
                                            </Button>

                                            <Button
                                                size='large'
                                                color='success'
                                                sx={{ mr: 2, width: 250 }}
                                                variant='contained'
                                                onClick={() => setModeSave('save-oto')}
                                                type='submit'
                                            >
                                                Otorisasi & Simpan
                                            </Button>
                                        </>
                                    )
                                } else if (isOto == 0) {
                                    return (
                                        <>
                                            <Button
                                                size='large'
                                                sx={{ mr: 2, width: 150 }}
                                                variant='contained'
                                                onClick={() => setModeSave('save')}
                                                type='submit'
                                            >
                                                Simpan
                                            </Button>
                                        </>
                                    )
                                } else {
                                    return <div></div>
                                }
                            })()}
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
